// draggableFixedSize.js
export const draggableFixedSize = {
  mounted(el, binding) {
    const options = binding.value || {}
    const dynamic = options.dynamic === true
    const viewportPadding = Number.isFinite(options.viewportPadding)
      ? Math.max(0, options.viewportPadding)
      : 0

    let isDragging = false
    let offsetX = 0
    let offsetY = 0

    if (!dynamic) {
      // Legacy behavior for fixed-size dialogs.
      el.style.width = `${el.offsetWidth}px`
      el.style.height = `${el.offsetHeight}px`
    }

    const clampPosition = (left, top) => {
      const maxLeft = Math.max(viewportPadding, window.innerWidth - el.offsetWidth - viewportPadding)
      const maxTop = Math.max(viewportPadding, window.innerHeight - el.offsetHeight - viewportPadding)
      return {
        left: Math.max(viewportPadding, Math.min(left, maxLeft)),
        top: Math.max(viewportPadding, Math.min(top, maxTop)),
      }
    }

    const keepInsideViewport = () => {
      const rect = el.getBoundingClientRect()
      const outsideViewport = rect.left < viewportPadding
        || rect.top < viewportPadding
        || rect.right > window.innerWidth - viewportPadding
        || rect.bottom > window.innerHeight - viewportPadding

      if (!outsideViewport) return

      const position = clampPosition(rect.left, rect.top)
      el.style.right = 'auto'
      el.style.bottom = 'auto'
      el.style.left = `${position.left}px`
      el.style.top = `${position.top}px`
    }

    const onMouseDown = (event) => {
      const rect = el.getBoundingClientRect()
      isDragging = true
      offsetX = event.clientX - rect.left
      offsetY = event.clientY - rect.top

      // A bottom-anchored element must switch to top/left coordinates before
      // dragging, otherwise dynamic height changes can stretch the container.
      el.style.right = 'auto'
      el.style.bottom = 'auto'
      el.style.left = `${rect.left}px`
      el.style.top = `${rect.top}px`
      document.body.style.userSelect = 'none'
    }

    const onMouseMove = (event) => {
      if (!isDragging) return
      const position = clampPosition(event.clientX - offsetX, event.clientY - offsetY)
      el.style.left = `${position.left}px`
      el.style.top = `${position.top}px`
    }

    const onMouseUp = () => {
      isDragging = false
      document.body.style.userSelect = ''
    }

    el.addEventListener('mousedown', onMouseDown)
    document.addEventListener('mousemove', onMouseMove)
    document.addEventListener('mouseup', onMouseUp)
    window.addEventListener('resize', keepInsideViewport)

    let resizeObserver = null
    if (dynamic && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(keepInsideViewport)
      resizeObserver.observe(el)
    }

    el.__draggableFixedSizeCleanup = () => {
      el.removeEventListener('mousedown', onMouseDown)
      document.removeEventListener('mousemove', onMouseMove)
      document.removeEventListener('mouseup', onMouseUp)
      window.removeEventListener('resize', keepInsideViewport)
      if (resizeObserver) resizeObserver.disconnect()
      document.body.style.userSelect = ''
    }
  },

  beforeUnmount(el) {
    if (el.__draggableFixedSizeCleanup) {
      el.__draggableFixedSizeCleanup()
      delete el.__draggableFixedSizeCleanup
    }
  },
}
